import { SCHEDULE_ACCENTS, type TimelineAccent } from "@/shared/timeline";

/** Map JS day index (0=Sun) to FHIR day code */
export const DAY_INDEX_TO_CODE: Record<number, string> = {
  0: "sun",
  1: "mon",
  2: "tue",
  3: "wed",
  4: "thu",
  5: "fri",
  6: "sat",
};

/**
 * A schedule's colour is its IDENTITY, not its status: hue says whose column
 * this is, and nothing else. The palettes themselves live in the timeline's
 * accent table so a block on the calendar and a block on a plan are tinted by
 * one source.
 *
 * The roster must be EVERY schedule, never the selected subset. Indexing into
 * the selection made a practitioner's colour depend on who else was on screen,
 * so unticking one name in the filter recoloured everyone after it — and the
 * filter bar's own chip and picker row disagreed about the same schedule,
 * because one passed the selection and the other passed the roster. Identity
 * that changes when you filter is not identity.
 */
export function getScheduleAccent(scheduleId: string, allScheduleIds: string[]): TimelineAccent {
  const sorted = [...allScheduleIds].sort();
  const index = sorted.indexOf(scheduleId);
  return SCHEDULE_ACCENTS[(index === -1 ? 0 : index) % SCHEDULE_ACCENTS.length];
}

export { SCHEDULING_PARAMS_URL } from "@repo/api";
export { ALL_DAYS } from "@/features/scheduling/lib/constants";
